/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { Component, OnDestroy, OnInit } from '@angular/core';

import { AppUtilityService } from '../../services/app-utility.service';
import { LmsLoaderService } from '../../services/lms-loader.service';
import { LmsTerminalStatusSubmenuService } from './../../../core/services/lms-terminal-status-submenu.service';

/**
 * @export
 * @class LmsTerminalStatusSubmenuComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-terminal-status-submenu',
  templateUrl: './lms-terminal-status-submenu.component.html',
  styleUrls: ['./lms-terminal-status-submenu.component.scss']
})
export class LmsTerminalStatusSubmenuComponent implements OnInit, OnDestroy {
  terminalStatusMenuSubscription: any;
  statusList: Array<Object>;
  constructor(private lmsTerminalStatusSubmenuService: LmsTerminalStatusSubmenuService,
    private appUtilService: AppUtilityService, private lmsLoaderService: LmsLoaderService) {
    this.terminalStatusMenuSubscription = this.lmsTerminalStatusSubmenuService.terminalStatusMenu.subscribe(data => {
      this.statusList = data;
    });
  }

  /**
   * Initialize the state of lifecycle hook.
   * @memberOf LmsTerminalStatusSubmenuComponent
   */
  ngOnInit() {
  }

  /**
   * in this method we are checking checkbox state
   * on check and uncheck and emit an event which
   * will listen by terminal component
   * @param {any} status
   * @param {any} $event
   * @memberOf LmsTerminalStatusSubmenuComponent
   */
  changeStatus() {
    this.lmsTerminalStatusSubmenuService.updateStatusListValue(this.statusList);
    // window.scrollTo(0, document.body.scrollHeight);
  }

  /**
   * Destroy the state of lifecycle hook.
   * @memberOf LmsTerminalStatusSubmenuComponent
   */
  ngOnDestroy() {
    this.terminalStatusMenuSubscription.unsubscribe();
  }
}
